/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type HomeScreenEventsList_query = {
    readonly upcomingEvents: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"EventCard_event">;
            };
        }>;
    } | null;
    readonly pastEvents: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"EventCard_event">;
            };
        }>;
    } | null;
    readonly " $refType": "HomeScreenEventsList_query";
};
export type HomeScreenEventsList_query$data = HomeScreenEventsList_query;
export type HomeScreenEventsList_query$key = {
    readonly " $data"?: HomeScreenEventsList_query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"HomeScreenEventsList_query">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventCard_event"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeScreenEventsList_query",
  "selections": [
    {
      "alias": "upcomingEvents",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "timeSelection",
          "value": "UPCOMING"
        }
      ],
      "concreteType": "EventsConnection",
      "kind": "LinkedField",
      "name": "eventsByTimeSelection",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "eventsByTimeSelection(first:4,timeSelection:\"UPCOMING\")"
    },
    {
      "alias": "pastEvents",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "timeSelection",
          "value": "PAST"
        }
      ],
      "concreteType": "EventsConnection",
      "kind": "LinkedField",
      "name": "eventsByTimeSelection",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "eventsByTimeSelection(first:4,timeSelection:\"PAST\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
(node as any).hash = '6c472767c4f3e7678013d935c1811a41';
export default node;
